export const COIN_SEQUENCE = ['GRAM', 'BTC', 'RVN', 'ETC', 'DNX', 'KAS', 'LTCBTC'];

export const DEFAULT_COIN = COIN_SEQUENCE[4];

export const VIEWS = {
  WORKERS: 'workers',
  PAYOUTS: 'payouts',
}

export const NETWORK_COINS = {
  BTC: 'BTC',
  GRAM: 'TON',
  LTCBTC: 'LTCBTC',
  ETC: 'ETC',
  RVN: 'RVN',
}

export const COIN_WITH_SUBACCOUNTS = ['GRAM', 'BTC', 'ETC', 'KAS', 'DNX', 'RVN', 'LTCBTC' ];

export const COIN_ROUTES = {
  '': 'BTC',
  'btc': 'BTC',
  'etc': 'ETC',
  'ethereum-classic': 'ETC',
  'gram': 'GRAM',
  'rvn': 'RVN',
  'ravencoin': 'RVN',
  'kas': 'KAS',
  'kaspa': 'KAS',
  'dnx-mining-pool': 'DNX',
  'ltcbtc': 'LTCBTC',
};

export const COIN_LANDING = {
  'btc': '',
  'etc': 'ethereum-classic',
  'gram': 'gram',
  'rvn': 'ravencoin',
  'kas': 'kaspa',
  'dnx': 'dnx-mining-pool',
  'ltcbtc': 'ltcbtc',
};

export const ACCOUNT_PATHES = {
  gram: 'gram',
  etc: 'etc',
  btc: 'btc',
  rvn: 'rvn',
  kas: 'kas',
  dnx: 'dnx-mining-pool',
  ltcbtc: 'ltcbtc',
};

// Mapping from internal coin identifiers to display names
export const COIN_DISPLAY_NAMES = {
  'LTCBTC': 'LTC',
};

// Utility function to get display name for a coin
export const getCoinDisplayName = (coin: string): string => {
  return COIN_DISPLAY_NAMES[coin as keyof typeof COIN_DISPLAY_NAMES] || coin;
};
